import type { FrontofficeRuntime } from '../../runtime/frontofficeRuntime';

export type PosMenuItemId =
  | 'stock'
  | 'cloture'
  | 'inventaire'
  | 'reset'
  | 'quit'
  | 'profil'
  | 'logout';

export function posMenuItems(opts: {
  role: string;
  runtime: FrontofficeRuntime;
}): PosMenuItemId[] {
  const privileged = opts.role === 'manager' || opts.role === 'admin';
  const items: PosMenuItemId[] = ['stock'];
  if (privileged) {
    items.push('cloture', 'inventaire', 'reset');
  }
  if (opts.runtime === 'electron') {
    items.push('quit');
  }
  items.push('profil', 'logout');
  return items;
}
